import { Selection } from '@heroui/react'
import { create } from 'zustand'

type BlogSidebarState = {
  activeHeadline: Selection
  setActiveHeadline: (headline: Selection) => void
}

export const useBlogSidebarStore = create<BlogSidebarState>(set => ({
  activeHeadline: new Set(),
  setActiveHeadline: activeHeadline => set({ activeHeadline }),
}))
